import React, { useEffect, useState } from 'react';
import { useAdminAccess } from '../../hooks/useAdminAccess';
import { isValidUuid } from '../../lib/crm';
import { AdminStatusScreen } from './AdminStatusScreen';
import { AdminShell } from './AdminShell';
import { DashboardPage } from './DashboardPage';
import { EditProspectPage } from './EditProspectPage';
import { FollowUpsPage } from './FollowUpsPage';
import { NewProspectPage } from './NewProspectPage';
import { ProspectDetailPage } from './ProspectDetailPage';
import { ProspectsPage } from './ProspectsPage';
export function AdminCrmApp() {
  const {
    status,
    profile,
    user,
    message,
    refreshAccess,
    signOut
  } = useAdminAccess();
  const [, setNavigationVersion] = useState(0);
  const path = window.location.pathname.replace(/\/+$/, '') || '/admin';
  useEffect(() => {
    const onNavigation = () => {
      setNavigationVersion(current => current + 1);
    };
    window.addEventListener('popstate', onNavigation);
    return () => window.removeEventListener('popstate', onNavigation);
  }, []);
  useEffect(() => {
    if (status === 'unauthenticated') window.location.replace('/admin/login');
  }, [status]);
  if (status === 'unauthenticated') {
    return <AdminStatusScreen title="Validando acceso" message="Comprobando tu sesión segura." loading data-id="element-70" />;
  }
  if (status === 'loading' && (!profile || !user)) {
    return <AdminStatusScreen title="Validando acceso" message="Comprobando tu sesión segura." loading data-id="element-71" />;
  }
  if (status === 'inactive') {
    return <AdminStatusScreen title="Usuario desactivado" message="Esta cuenta no tiene acceso activo a TITÁN OS." tone="warning" data-id="element-72">
        <a href="/admin/login" className="mt-7 inline-flex min-h-11 w-full items-center justify-center rounded-xl border border-cyan-300/30 bg-cyan-300/10 px-4 text-sm font-semibold text-cyan-100" data-id="element-73">
          Volver al inicio de sesión
        </a>
      </AdminStatusScreen>;
  }
  if (status === 'configuration-error' || status === 'error' || status === 'profile-missing') {
    return <AdminStatusScreen title="Acceso no disponible" message={message} actionLabel="Reintentar" onAction={() => void refreshAccess()} tone="warning" data-id="element-74" />;
  }
  if (!profile || !user) return null;
  const editMatch = path.match(/^\/admin\/prospectos\/([^/]+)\/editar$/);
  const detailMatch = path.match(/^\/admin\/prospectos\/([^/]+)$/);
  let page = <DashboardPage data-id="element-75" />;
  if (path === '/admin/prospectos/nuevo') {
    page = <NewProspectPage profile={profile} data-id="element-76" />;
  } else if (editMatch && isValidUuid(editMatch[1])) {
    page = <EditProspectPage profile={profile} prospectId={editMatch[1]} data-id="element-77" />;
  } else if (detailMatch && isValidUuid(detailMatch[1])) {
    page = <ProspectDetailPage profile={profile} prospectId={detailMatch[1]} data-id="element-78" />;
  } else if (path === '/admin/prospectos') {
    page = <ProspectsPage profile={profile} data-id="element-79" />;
  } else if (path === '/admin/seguimientos') {
    page = <FollowUpsPage profile={profile} data-id="element-80" />;
  } else if (editMatch) {
    page = <InvalidProspectRoute segment={editMatch[1]} data-id="element-81" />;
  } else if (detailMatch) {
    page = <InvalidProspectRoute segment={detailMatch[1]} data-id="element-82" />;
  }
  return <AdminShell profile={profile} onSignOut={() => void signOut()} data-id="element-83">
      {page}
    </AdminShell>;
}
function InvalidProspectRoute({
  segment
}: {
  segment: string;
}) {
  const reservedSegments = new Set(['nuevo', 'editar', 'seguimiento', 'configuracion']);
  const isReserved = reservedSegments.has(segment.toLowerCase());
  return <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8" data-id="element-84">
      <section className="rounded-2xl border border-amber-300/20 bg-amber-300/10 p-6" data-id="element-85">
        <p className="font-orbitron text-xs font-bold tracking-[.16em] text-amber-200" data-id="element-86">
          RUTA NO DISPONIBLE
        </p>
        <h1 className="mt-3 text-2xl font-bold text-white" data-id="element-87">
          {isReserved ? 'Esta ruta no está disponible.' : 'Prospecto no válido.'}
        </h1>
        <p className="mt-2 text-sm leading-6 text-slate-300" data-id="element-88">
          No se consultó ningún registro porque la ruta no contiene un
          identificador de prospecto válido.
        </p>
        <a href="/admin/prospectos" className="mt-5 inline-flex min-h-11 items-center rounded-xl bg-cyan-300 px-4 text-sm font-bold text-[#06202a]" data-id="element-89">
          Volver a prospectos
        </a>
      </section>
    </div>;
}